export const ACCOUNT_CREATE_RESET = 'ACCOUNT_CREATE_RESET'
export const ACCOUNT_CREATE_SET_CREATED = 'ACCOUNT_CREATE_SET_CREATED'
export const ACCOUNT_CREATE_SET_ERROR = 'ACCOUNT_CREATE_SET_ERROR'
export const ACCOUNT_CREATE_SET_VIOLATIONS = 'ACCOUNT_CREATE_SET_VIOLATIONS'
export const ACCOUNT_CREATE_TOGGLE_LOADING = 'ACCOUNT_CREATE_TOGGLE_LOADING'
